import cookies from 'js-cookie'
import { isDev } from '../../app/helpers/utils'

const devCartUrl = 'https://cart-consumer-js.cloud.photoforse.online'
const prodCartUrl = 'https://checkout.photosi.com'

export const handleRedirectToNewCart = () => {
  const isNewCartEnabled = !!cookies.get('isUsingNewCart')

  if (!isNewCartEnabled) {
    return
  }

  try {
    const newCartBaseUrl = isDev() ? devCartUrl : prodCartUrl

    const currentParams = new URLSearchParams(window.location.search)
    const destinationUrl = new URL(newCartBaseUrl)
    destinationUrl.search = currentParams.toString()

    window.location.replace(destinationUrl.toString())
  } catch (error) {
    console.error('Failed to redirect to the new cart:', error)
  }
}
